export const styles = (theme) => ({
  dialogRoot: {
    [theme.breakpoints.up('md')]: {
      maxWidth: 600,
    },
    [theme.breakpoints.down('sm')]: {
      maxWidth: '100%',
      margin: 0,
    },
  },
  fields: {
    display: 'flex',
    flexDirection: 'column',
    width: 300,
    gap: theme.spacing(2),
  },
  confirmBtn: {
    width: 140,
    textTransform: 'none',
    boxShadow: 'none',
    '&:disabled': {
      color: theme.palette.secondary.main,
    },
    // The theme-wide MuiButton root whitens the background on focus — keep the filled look.
    '&:hover, &:focus': {
      background: theme.palette.primary.main,
      color: theme.palette.textColor.white,
    },
  },
  visibilityToggle: {
    // The global MuiTextField override zeroes the input wrapper's padding — inset the adornment itself.
    padding: theme.spacing(0.5, 1),
    border: 'none',
    background: 'none',
    cursor: 'pointer',
  },
  error: {
    color: theme.palette.textColor.red,
    padding: '0 5px',
    fontSize: 11,
    marginTop: 8,
  },
});
